import { Button, ConfigProvider, Form, Input, Row, Typography } from 'antd'
import { Link, useSearchParams } from 'react-router-dom'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { LoginHand } from '../../store/Auth/LoginSlice'
import useTranslation from '../../localization/useTranslation'
import LanguageToggler from '../../components/LanguageToggler/LanguageToggler'
import ValidationErrorAlert from '../../components/ValidationErrorAlert'
import { applyValidationErrorsToForm } from '../../utilities/handleApiValidationError'
import { brand, getAntdTheme } from '../../theme/palette'

const LogIn = () => {
    const dispatch = useDispatch()
    const { loading, errorMessages, fieldErrors } = useSelector((state) => state.login)
    const [from] = Form.useForm()
    const { t, language } = useTranslation()
    const [searchParams] = useSearchParams()

    useEffect(() => {
        const emailFromQuery = searchParams.get('email')
        if (emailFromQuery) {
            from.setFieldsValue({ email: emailFromQuery })
        }
    }, [searchParams, from])

    useEffect(() => {
        if (fieldErrors) {
            applyValidationErrorsToForm(from, fieldErrors, language)
        }
    }, [fieldErrors, from, language])

    const onFinish = (values) => {
        dispatch(LoginHand(values))
    }

    return (
        <ConfigProvider theme={getAntdTheme('light')}>
            <ValidationErrorAlert
                messages={errorMessages}
                title={t('common.validationError')}
            />

            <Row style={{ height: "100vh", position: 'relative', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                {/* positioned toggler in the corner */}
                <div style={{ position: 'absolute', top: 12, right: 12, zIndex: 1000 }}>
                    <LanguageToggler variant="round" />
                </div>

                <div style={{ width: 420, maxWidth: '92%', padding: 20, boxSizing: 'border-box' }}>
                    <div style={{ textAlign: 'center', marginBottom: 24 }}>
                        <Typography.Title level={3} style={{ marginBottom: 4, color: brand.navy }}>
                            Dentrist
                        </Typography.Title>
                        <Typography.Text type="secondary" style={{ display: 'block', marginBottom: 8 }}>
                            {t('auth.login.vendorSubtitle')}
                        </Typography.Text>
                        <span
                            style={{
                                display: 'inline-block',
                                padding: '2px 10px',
                                borderRadius: 999,
                                fontSize: 12,
                                fontWeight: 600,
                                color: brand.primary,
                                background: brand.soft,
                                border: `1px solid ${brand.muted}`,
                            }}
                        >
                            {t('auth.login.vendorTitle')}
                        </span>
                    </div>

                    <div>
                        <Form dir={language === 'ar' ? 'rtl' : 'ltr'} form={from} onFinish={onFinish} labelCol={{ span: 24 }}>
                            <Form.Item
                                name='email'
                                label={t('auth.login.identifier.label')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('auth.login.identifier.required'),
                                    },
                                ]}
                            >
                                <Input placeholder={t('auth.login.identifier.placeholder')} autoComplete="username" />
                            </Form.Item>
                            <Form.Item
                                name='password'
                                label={t('auth.login.password.label')}
                                rules={[
                                    {
                                        required: true,
                                        message: t('auth.login.password.required'),
                                    },
                                ]}
                            >
                                <Input.Password placeholder={t('auth.login.password.placeholder')} autoComplete="current-password" />
                            </Form.Item>
                            <Form.Item>
                                <Button block type="primary" htmlType="submit" loading={loading}>
                                    {t('auth.login.submit')}
                                </Button>
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 0, textAlign: 'center' }}>
                                <Link to="/forgot-password">{t('auth.login.forgotPassword')}</Link>
                            </Form.Item>
                        </Form>
                    </div>
                </div>
            </Row>
        </ConfigProvider>
    )
}

export default LogIn
